import React from 'react';
import { motion } from 'framer-motion';
const results = [{
  id: 1,
  treatment: 'Protocolo Anti-Age Facial',
  timeframe: 'Después de 3 sesiones',
  image: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?q=80&w=2070&auto=format&fit=crop'
}, {
  id: 2,
  treatment: 'Modelado Corporal',
  timeframe: 'Después de 6 semanas',
  image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?q=80&w=2070&auto=format&fit=crop'
}, {
  id: 3,
  treatment: 'Limpieza Profunda + Peeling',
  timeframe: 'Resultado inmediato',
  image: 'https://images.unsplash.com/photo-1616683693504-3ea7e9ad6fec?q=80&w=1974&auto=format&fit=crop'
}];
export function Results() {
  return <section id="resultados" className="py-24 bg-deepblack text-white relative overflow-hidden" data-id="element-171">
      {/* Decorative background text */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[15vw] font-serif font-bold text-white/[0.02] whitespace-nowrap pointer-events-none select-none" data-id="element-172">
        TRANSFORMACIÓN
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-173">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-174">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-serif mb-6" data-id="element-175">
            Resultados que hablan por{' '}
            <span className="italic text-rosegold font-light" data-id="element-176">sí solos</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-white/70 font-sans font-light text-lg" data-id="element-177">
            La evidencia de nuestro compromiso con la excelencia y tu bienestar.
            Cada tratamiento es personalizado para lograr tu mejor versión.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-178">
          {results.map((result, index) => <motion.div key={result.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.7,
          delay: index * 0.2
        }} className="group cursor-pointer" data-id="element-179">
              <div className="relative aspect-[4/5] overflow-hidden rounded-xl mb-6" data-id="element-180">
                <img src={result.image} alt={result.treatment} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-181" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500" data-id="element-182"></div>

                {/* Simulated Before/After Badge */}
                <div className="absolute top-4 right-4 bg-white/10 backdrop-blur-md border border-white/20 text-white text-xs px-3 py-1 rounded-full uppercase tracking-widest" data-id="element-183">
                  Caso Real
                </div>
              </div>

              <div className="text-center" data-id="element-184">
                <h3 className="text-xl font-serif mb-2 group-hover:text-rosegold transition-colors" data-id="element-185">
                  {result.treatment}
                </h3>
                <p className="text-sm font-sans text-white/50 uppercase tracking-widest" data-id="element-186">
                  {result.timeframe}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}